import React from 'react';
import { ReactComponent as FigCreditCardRefreshComponent } from './FigCreditCardRefresh.svg';

const FigCreditCardRefresh = (props) => (
  <FigCreditCardRefreshComponent {...props} />
);

export default FigCreditCardRefresh;
